import {Component, Input, OnInit} from '@angular/core';
import {ResultatService} from '../../../services/resultat.service';

@Component({
  selector: 'app-resultat-table',
  templateUrl: './resultat-table.component.html',
  styleUrls: []
})
export class ResultatTableComponent implements OnInit {

  @Input() resultatDtos: any;
  @Input() resultatSummaDto: any;

  hasAterbetalningsbelopp = false;

  constructor(private readonly resultatService: ResultatService) { }

  ngOnInit() {
    this.hasAterbetalningsbelopp = this.resultatService.hasAterbetalningsbelopp;
  }

  tranformDigit(value: string): string {
    return this.resultatService.tranformDigitToLocaleString(+value);
  }
}
